import { defineStore } from "pinia";
import type { LocationQuery } from "vue-router";

interface FeatureFlagsState {
  newOAuthScopes: boolean;
}

export const useFeatureFlagsStore = defineStore("featureFlags", {
  state: (): FeatureFlagsState => ({
    newOAuthScopes: false,
  }),
  actions: {
    ingestFromQuery(query: LocationQuery) {
      if (typeof query.newOAuthScopes !== "string") {
        return;
      }

      this.newOAuthScopes = query.newOAuthScopes === "true";
    },
    setNewOAuthScopes(enabled: boolean) {
      this.newOAuthScopes = enabled;
    },
    reset() {
      this.newOAuthScopes = false;
    },
  },
  persist: {
    storage: sessionStorage,
    pick: ["newOAuthScopes"],
  },
});
